import { Button, DialogActions } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { I18n } from 'aws-amplify';
import { onConfirmChangeForm } from '../handler/KnowledgeTicketHandler';

export default function DialogSelectFormKnowledgeTicket({argsAll}) {
    const onCloseDialogReject = () => {
        argsAll.setIsOpenDialogSelectForm({isOpen: false, value: ''});
    };

    return (
        <Dialog
            open={argsAll.isOpenDialogSelectForm.isOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirmPlease">{I18n.get('USER04MSG017')}</div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    variant="contained"
                    className="btn-hg32 btn-handle-delete-user-agree"
                    onClick={async () => await onConfirmChangeForm(argsAll.isOpenDialogSelectForm.value, argsAll)}
                >
                    {I18n.get('COMBTN002')}
                </Button>

                <Button
                    variant="contained"
                    className="btn-light btn-hg32"
                    onClick={onCloseDialogReject}
                >
                    {I18n.get('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
